var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:("Badge_" + (_vm.params.value) + " mr-1"),attrs:{"title":("" + (_vm.applicationStatusTranslation[_vm.params.value]))}},[_vm._v(" "+_vm._s(_vm.applicationStatusTranslation[_vm.params.value])+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }